import React, {useEffect} from 'react';
import Box from '@material-ui/core/Box';
import dashboardActions from '../../../actions/dashboard.actions';
import {ConfigState} from '../../../reducers/config';
import {useDispatch, useSelector} from 'react-redux';
import {selectEarnings} from '../../../selectors';
import {MyCreatorCode, MyPayoutEligibility, MyEarnings} from '../components';

export interface EarningSectionProps {
    className?: string;
    creatorCode: string;
    configState: ConfigState;
    messages: Record<string, string>;
}

const EarningSection: React.FC<EarningSectionProps> = ({messages, creatorCode, configState}) => {
    const dispatch = useDispatch();
    const earnings = useSelector(selectEarnings);
    const isRendering = !earnings.lastFetch;

    useEffect(() => {
        dispatch(dashboardActions.getEarningsData({version: 2}));
    }, []);

    return (
        <Box>
            <MyCreatorCode
                isRendering={isRendering}
                earnings={earnings}
                creatorCode={creatorCode}
                configState={configState}
            />
            <MyPayoutEligibility isRendering={isRendering} earnings={earnings} />
            <MyEarnings isRendering={isRendering} earnings={earnings} i18nMessages={messages} />
        </Box>
    );
};

export default EarningSection;
